import { selectorFamily } from "recoil";

import { FieldTypeTarget } from "../../enums";
import { ISelectListItem } from "../../models";
import { fieldTypesAtom } from "../atoms";

export const fieldTypeSelectListForTargetSF = selectorFamily<
  ISelectListItem[],
  FieldTypeTarget
>({
  key: "fieldTypeSelectListForTargetSF",
  get:
    target =>
    ({ get }) => {
      const fieldTypesAll = get(fieldTypesAtom);
      const fieldTypesDtos = fieldTypesAll?.filter(x => x.target === target);
      const items: ISelectListItem[] | undefined = fieldTypesDtos?.map(x => ({
        value: x.id,
        label: x.name,
      }));
      return items || [];
    },
});
